<template>
    <div>
        <van-grid :border="false" :column-num="3">
            <van-grid-item v-for="(ele,index) in data" :key="index">
              <div class="num-wrapper" >
                <p class="num-p" @click="chooseOne(ele.mark)">{{ele.type==='price'?priceTrans(ele.value):ele.value}}</p>
                <p class="ins-p">{{ele.text}}</p>
              </div>
            </van-grid-item>
          </van-grid>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
    name: "railwayData",
  components: {
  },
  props:{
    timeRange:{
      style:Number,
      default:0
    }
  },
  data() {
    return {
      active: 0,
      data:[]
    };
  },
  computed: {},
  methods: {
    link: function(value) {
      location.href = "/" + value;
    },
    chooseOne(value){
      this.$emit('clickMark',value);
    },
    priceTrans(value){
      return (parseFloat(value)/10000).toFixed(1).toString();
    },
    getQuantity() {
      this.$axios
        .post(this.$url + "/statistics", {
          userToken: userToken,
          askData: "railwayData",
          timeRange:this.timeRange
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.data = response.data.res_record;
          } else {
            this.$toast(response.data.error_info);
          }
        })
        .catch(error => {
          this.$toast("网络无法连接或" + error);
        });
    }
  },
  created() {
      this.getQuantity();
  }
    
}
</script>
<style scoped>

.num-wrapper {
  text-align: center;
}

.num-p {
  font-size: 1rem;
}

.ins-p {
  font-size: 0.5rem;
  color: #999;
  padding: 0.5rem 0;
}

</style>